// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Canvas-target agents: a persistent bar centered at the TOP of the canvas,
   just below the top menu bar. Node-target agents render at their node instead
   (NodeAgentBadges). */
.YlgAS_SilGk9dEQmktHx {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(var(--curio-top-bar-height) + 11px);
  z-index: 30;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: min(90vw, 720px);
}

/* A read-only canvas's dock, under its banner (UpMenu.module.css's
   \`.sharedBanner\`: 8px under the top bar, about 32px tall). */
.pUuFDxT2Y2GeqLgJM8xt {
  top: calc(var(--curio-top-bar-height) + 48px);
}

/* Avatar chips are the shared AgentAvatarBadge; the chat panel's styles live
   in AgentChatPanel.module.css (concept-aligned visual system). */

/* Who else is here (PeopleHere): a chip each, on the agents' chip, then the
   Activity button. One item of the dock's row, spaced as the row is. */
.yUDJMAazAq3RDZcNtk4E {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

/* A person's initials, in their color (set on the chip), where an agent's
   chip has its category's glyph. */
.XoxtHl8C4xRbAI9ttmbr {
  font-size: var(--curio-font-size-md);
  font-weight: 700;
  line-height: 1;
}

/* The room's Activity, opened from its button at the row's end. */
.ftX4uXsOFhwd8eTDMlpC {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 260px;
  max-height: 280px;
  overflow-y: auto;
  padding: 8px 10px;
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-browse-card-raised);
  color: var(--curio-text-primary);
  font-size: var(--curio-font-size-sm);
  line-height: var(--curio-line-height-sm);
  text-align: left;
}

.KJq_x0n8TW0uahTsGFnT {
  margin-bottom: 6px;
  font-size: var(--curio-font-size-xs);
  font-weight: 700;
  color: var(--curio-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.hQcj256gUVIvANvBZhS7 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.FfcOCQpy9zbkN4dKwW1M {
  margin: 0;
  color: var(--curio-text-muted);
}

/* The dataflow goal, shown in the dock beside the agents that read it.

   The label and the input travel together, so the field keeps its name once a
   value is typed and the placeholder is no longer there to carry it. */
.aFgP5zhc7vwlaId6XecQ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  /* The dock is a flex row and this is one of its items; without a min-width
     of 0 a flex item refuses to shrink below its content, which is what pushed
     the input past the dock's max-width and cropped it (#227). */
  min-width: 0;
  flex: 1 1 auto;
  max-width: 420px;
  /* The dock is absolutely positioned, so it is as wide as its content, and
     the input's \`width: 100%\` had nothing definite to fill: it fell back to
     about twenty characters and cut the placeholder (#227). A definite width
     gives it one; the flex line above still lets a crowded dock shrink it. */
  width: 320px;
}

.ruw6wyyDkTpbPe4Q1F4I {
  flex: 0 0 auto;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-secondary);
}

.fkRxntZAo6nb6OfLVQra {
  /* A real width, not a floor. \`\`min-width: 260px\`\` with no width made the
     input size to its CONTENT inside a flex row, so a placeholder longer than
     the box was simply clipped -- max-width never came into play. */
  width: 100%;
  min-width: 0;
  padding: 4px 10px;
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  background: var(--curio-surface-alt);
  color: var(--curio-text-primary);
  font-size: var(--curio-font-size-sm);
  /* A value longer than the field is the normal case for a goal, so say so
     rather than cutting a word in half. */
  text-overflow: ellipsis;
  outline: none;
}

.fkRxntZAo6nb6OfLVQra:focus {
  border-color: var(--curio-border-strong);
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/AgentDock.module.css"],"names":[],"mappings":"AAAA;;uBAEuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,6CAA6C;EAC7C,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;8DAC8D;AAC9D;EACE,6CAA6C;AAC/C;;AAEA;kEACkE;;AAElE;uEACuE;AACvE;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;mCACmC;AACnC;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,kDAAkD;EAClD,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;;;uEAGuE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;iEAE+D;EAC/D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB;;;6EAG2E;EAC3E,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE;;oEAEkE;EAClE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC;0CACwC;EACxC,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["/* Canvas-target agents: a persistent bar centered at the TOP of the canvas,\n   just below the top menu bar. Node-target agents render at their node instead\n   (NodeAgentBadges). */\n.dock {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: calc(var(--curio-top-bar-height) + 11px);\n  z-index: 30;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  max-width: min(90vw, 720px);\n}\n\n/* A read-only canvas's dock, under its banner (UpMenu.module.css's\n   `.sharedBanner`: 8px under the top bar, about 32px tall). */\n.dockBelowBanner {\n  top: calc(var(--curio-top-bar-height) + 48px);\n}\n\n/* Avatar chips are the shared AgentAvatarBadge; the chat panel's styles live\n   in AgentChatPanel.module.css (concept-aligned visual system). */\n\n/* Who else is here (PeopleHere): a chip each, on the agents' chip, then the\n   Activity button. One item of the dock's row, spaced as the row is. */\n.people {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* A person's initials, in their color (set on the chip), where an agent's\n   chip has its category's glyph. */\n.initials {\n  font-size: var(--curio-font-size-md);\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* The room's Activity, opened from its button at the row's end. */\n.activityList {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 260px;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 8px 10px;\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-browse-card-raised);\n  color: var(--curio-text-primary);\n  font-size: var(--curio-font-size-sm);\n  line-height: var(--curio-line-height-sm);\n  text-align: left;\n}\n\n.activityTitle {\n  margin-bottom: 6px;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 700;\n  color: var(--curio-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.activityItems {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.activityEmpty {\n  margin: 0;\n  color: var(--curio-text-muted);\n}\n\n/* The dataflow goal, shown in the dock beside the agents that read it.\n\n   The label and the input travel together, so the field keeps its name once a\n   value is typed and the placeholder is no longer there to carry it. */\n.goalField {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  /* The dock is a flex row and this is one of its items; without a min-width\n     of 0 a flex item refuses to shrink below its content, which is what pushed\n     the input past the dock's max-width and cropped it (#227). */\n  min-width: 0;\n  flex: 1 1 auto;\n  max-width: 420px;\n  /* The dock is absolutely positioned, so it is as wide as its content, and\n     the input's `width: 100%` had nothing definite to fill: it fell back to\n     about twenty characters and cut the placeholder (#227). A definite width\n     gives it one; the flex line above still lets a crowded dock shrink it. */\n  width: 320px;\n}\n\n.goalLabel {\n  flex: 0 0 auto;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-secondary);\n}\n\n.goalInput {\n  /* A real width, not a floor. ``min-width: 260px`` with no width made the\n     input size to its CONTENT inside a flex row, so a placeholder longer than\n     the box was simply clipped -- max-width never came into play. */\n  width: 100%;\n  min-width: 0;\n  padding: 4px 10px;\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  background: var(--curio-surface-alt);\n  color: var(--curio-text-primary);\n  font-size: var(--curio-font-size-sm);\n  /* A value longer than the field is the normal case for a goal, so say so\n     rather than cutting a word in half. */\n  text-overflow: ellipsis;\n  outline: none;\n}\n\n.goalInput:focus {\n  border-color: var(--curio-border-strong);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dock": `YlgAS_SilGk9dEQmktHx`,
	"dockBelowBanner": `pUuFDxT2Y2GeqLgJM8xt`,
	"people": `yUDJMAazAq3RDZcNtk4E`,
	"initials": `XoxtHl8C4xRbAI9ttmbr`,
	"activityList": `ftX4uXsOFhwd8eTDMlpC`,
	"activityTitle": `KJq_x0n8TW0uahTsGFnT`,
	"activityItems": `hQcj256gUVIvANvBZhS7`,
	"activityEmpty": `FfcOCQpy9zbkN4dKwW1M`,
	"goalField": `aFgP5zhc7vwlaId6XecQ`,
	"goalLabel": `ruw6wyyDkTpbPe4Q1F4I`,
	"goalInput": `fkRxntZAo6nb6OfLVQra`
};
export default ___CSS_LOADER_EXPORT___;
